import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';
import * as clientsActions from './clients.actions';
import * as ClientsSelectors from './clients.selectors';
import { ClientsState } from './clients.reducer';
import { ClientInterface, ClientInterfaceWithId } from '@sk/sk-interfaces';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';



@Injectable()
export class ClientsFacade {
  clientsLoaded$ = this.store.pipe(select(ClientsSelectors.getClientsLoaded));
  allClients$ = this.store.pipe(select(ClientsSelectors.getAllClients));
  allActiveClients$ = this.store.pipe(select(ClientsSelectors.getActiveClients));
  allClientEntities$ = this.store.pipe(select(ClientsSelectors.getClientsEntities));
  getClientName$ = this.store.pipe(select(ClientsSelectors.getActiveClients));
  selectedClients$ = this.store.pipe(select(ClientsSelectors.getSelected));
  addErrors$ = this.store.pipe(select(ClientsSelectors.getAddClientError))
  addLoader$ = this.store.pipe(select(ClientsSelectors.getAddClientLoaded))
  queryErrors$ = this.store.pipe(select(ClientsSelectors.getQueryLoadError))


  constructor(private store: Store<ClientsState>) {
  }


  loadClientsFromFirestore() {
    this.store.dispatch(clientsActions.queryFireStoreClients({}));
  }

  deleteClient(client: ClientInterfaceWithId) {
    this.store.dispatch(clientsActions.removeClient({
      id: client.id,
    }));
  }

  addClient(client: ClientInterface) {
    const obj = {
      ...client as ClientInterface,
      id: null,
      exists: false
    } as ClientInterfaceWithId;
    this.store.dispatch(clientsActions.addClient({
      client: obj
    }));
  }

  updateClient(client: ClientInterfaceWithId, changes: Partial<ClientInterfaceWithId>) {
    this.store.dispatch(clientsActions.updateClient({
      id: client.id,
      changes
    }));
  }

  getClientById(id : string) : Observable<ClientInterfaceWithId>{
    return this.store.select(ClientsSelectors.getAllClients)
      .pipe(
        map(list => list.find(item => item.id === id))
      )
  }


}
